import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionCampaignModel} from '../../models/promotion-campaign.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {Observable} from 'rxjs';

@Injectable()
export class PromotionCampaignService extends IService<PromotionCampaignModel> {

  static parseFromCharToBoolean(elem: any) {
    elem.flag_pressure_rules = elem.flag_pressure_rules === '1';
  }

  static parseFromBooleanToChar(elem: any) {
    elem.flag_pressure_rules = elem.flag_pressure_rules === true ? '1' : '0';
  }

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'campaign')
  }

  getTouchPoints(id: number) {
    return this._http.get(`${this.baseUrl}/${this.entityUrl}/${id}/touch-point`)
  }

  postTouchPoint(id: number, tp: Array<number>) {
    return this._http.post(`${this.baseUrl}/${this.entityUrl}/${id}/touch-point`, tp)
  }

  deleteTouchPoint(id: number) {
    return this._http.delete(`${this.baseUrl}/${this.entityUrl}/${id}/touch-point`)
  }

  create(model: PromotionCampaignModel): Observable<PromotionCampaignModel> {
    PromotionCampaignService.parseFromBooleanToChar(model);
    return super.create(model);
  }
  
  update(model: PromotionCampaignModel): Observable<PromotionCampaignModel> {
    PromotionCampaignService.parseFromBooleanToChar(model);
    return super.update(model);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-campaign.service.ts